import React from "react";
import { useNavigate } from "react-router-dom";

import { AuthCard } from "../../../common/u1/AuthCard";
import { AuthHeader } from "../../../common/u1/AuthHeader";
import { Button } from "../../../common/u1/Button";
import { ArrowRight, CheckIcon } from "../../../../assets/ui/icons";

/* Step 4 — success. Reached only by the step machine's handleNameNext. In practice the password step ends at its own dialog and navigates away from there, so... */
export const DoneStep = () => {
  const navigate = useNavigate();

  return (
    <AuthCard>
      <div className="w-full text-center">
        <span
          aria-hidden="true"
          className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-[var(--success)]/10 text-[var(--success)]"
        >
          <CheckIcon size={26} />
        </span>

        <AuthHeader
          title="Password changed successfully"
          subtitle="You can now log in with your new password."
        />

        <Button
          variant="primary"
          size="lg"
          className="mt-6 w-full"
          onClick={() => navigate("/login")}
        >
          Back to log in <ArrowRight size={14} />
        </Button>
      </div>
    </AuthCard>
  );
};

export default DoneStep;
